import { Link, useRouteError } from 'react-router';
import { Compass, RefreshCw } from 'lucide-react';
import { Button } from '@/design/components/Button';
import { EmptyState } from '@/design/components/Display';

export function RouteError() {
  const error = useRouteError() as Error | undefined;
  // A new deploy renamed the chunks this tab still points to: reload to get the current ones.
  const stale = !!error?.message && /dynamically imported module|Importing a module script failed/i.test(error.message);
  return (
    <div className="mx-auto max-w-xl p-10">
      <EmptyState
        icon={<RefreshCw className="size-6" />}
        title={stale ? 'Hay una versión nueva del sistema' : 'Algo no salió bien'}
        action={
          <Button variant="gold" onClick={() => window.location.reload()}>
            Recargar
          </Button>
        }
      >
        {stale ? 'Recargá la página para seguir.' : 'Recargá la página. Si vuelve a pasar, avisanos qué estabas haciendo.'}
      </EmptyState>
    </div>
  );
}

export function NotFound() {
  return (
    <div className="mx-auto max-w-xl py-10">
      <EmptyState
        icon={<Compass className="size-6" />}
        title="Esta pantalla no existe"
        action={
          <Link to="/inicio">
            <Button variant="gold">Volver al inicio</Button>
          </Link>
        }
      >
        Puede que el enlace esté incompleto.
      </EmptyState>
    </div>
  );
}
